var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicronesia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#83b2da",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15 3.63-.59 1.81h-1.9l1.54 1.12-.6 1.82L15 7.25l1.54 1.13-.59-1.82 1.55-1.12h-1.91zm6.53 8.93 1.73-.56-1.73-.56V9.63l-1.07 1.46-1.72-.56L19.8 12l-1.07 1.47 1.72-.56 1.07 1.47zm-5.58 4.88.6-1.82L15 16.76l-1.54-1.12.59 1.8-1.54 1.13h1.9l.59 1.81.59-1.81h1.9zm-6.41-6.35L8.47 9.63v1.8L6.74 12l1.73.56v1.81l1.07-1.46 1.72.56L10.2 12l1.06-1.47z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicronesia);
export default __webpack_public_path__ + "static/media/micronesia.ceda541375b1d0e37359d0ed677f42e6.svg";
export { ForwardRef as ReactComponent };